export type PermissionsByProvider = {
  ctt: 'ctt:admin' | 'ctt:admin2'
}

export type Permission = string
export type Provider = keyof PermissionsByProvider
export type PermissionCondition = Permission | {
  any?: PermissionCondition[]
}

/**
 * Функция для вычисления удовлетворения условиям прав
 */
export function satisfyCondition (condition: PermissionCondition, permissions: Permission[]): boolean {
  if (typeof condition === 'string') {
    return permissions.includes(condition)
  }

  return condition.any ? condition.any.some((c) => satisfyCondition(c, permissions)) : false
}
